import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-webinar04',
  templateUrl: './webinar04.component.html',
  styleUrls: ['./webinar04.component.scss']
})
export class Webinar04Component implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Improving Research Manuscripts Using AI-Powered Insights: Enago Reports");
    this.metaTagService.updateTag({ name: 'description', content: "Academic writing revolves around effectively conveying complex ideas with precision and nuance while maintaining readability, accessibility, and inclusivity." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Improving Research Manuscripts Using AI-Powered Insights: Enago Reports" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Academic writing revolves around effectively conveying complex ideas with precision and nuance while maintaining readability, accessibility, and inclusivity." });
    this.metaTagService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaTagService.updateTag({ name: 'twitter:site', content: '@thetrinkaai' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Improving Research Manuscripts Using AI-Powered Insights: Enago Reports" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Academic writing revolves around effectively conveying complex ideas with precision and nuance while maintaining readability, accessibility, and inclusivity." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports' });
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  stopAllVideos() {
    const iframes = document.querySelectorAll('iframe.youtubeVideoForTryDemo');
    iframes.forEach((iframe: HTMLIFrameElement) => {
      iframe.src = iframe.src; // Setting src to the same value pauses the video
    });
  }

  scrollToElementWithOffset(id: string, offset: number = 0) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }

  

}
